import {stringify} from 'qs'

import {CancellationPenalty} from '@vio/core/src/offer/types/offer'

import {PriceWatchRoom, PriceWatchTrackedRoom} from '../types'

export const serializeCancellationPenalties = (
  cancellationPenalties: CancellationPenalty[]
): string[] =>
  cancellationPenalties.map(({start, end, amount, currency}) =>
    [start, end, amount, currency].join('|')
  )

/** Maps the trackings read-API room (`id`) to the create payload shape (`roomId`). */
export const trackedRoomToCreateRoom = (
  room?: PriceWatchTrackedRoom
): PriceWatchRoom | undefined =>
  room?.id && room.name
    ? {
        roomId: room.id,
        name: room.name,
        ...(room.masterId && {masterId: room.masterId}),
        ...(room.boardType && {boardType: room.boardType})
      }
    : undefined

interface GetCallbackUrlParams {
  hotelId: string
  componentName?: string
}

/**
 * Utility function to build the params to enable the price watch after authenticating
 * e.g. www.vio.com/Hotel/Search?hotelId=1209184&checkIn=2024-08-22&checkOut=2024-08-23&rooms=2&enablePriceWatch=1209184
 */
export const getCallbackUrl = ({
  hotelId,
  componentName
}: GetCallbackUrlParams) => {
  const defaultPriceWatchParams = {
    enablePriceWatch: hotelId,
    ...(componentName && {componentPriceWatch: componentName})
  }

  const {origin, pathname, search} = new URL(window.location.href)
  const separator = search ? '&' : '?'

  return `${origin}${pathname}${search}${separator}${stringify(
    defaultPriceWatchParams
  )}`
}
